module.exports = __webpack_public_path__ + "img/landscape-product-description.5db6e65a.png";